import type { SvgIconPropsWithChildren } from '../components/SvgIcon/index.js';

import React, { createElement } from 'react';

import { SvgIcon } from '../components/SvgIcon/index.js';

function SvgLogin(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6529 3.02412C14.39 2.93962 14.1084 3.08424 14.0239 3.34714C13.9394 3.61004 14.084 3.89166 14.3469 3.97615C17.6085 5.02444 19.9999 8.21088 19.9999 12.0001C19.9999 15.7894 17.6085 18.9758 14.3469 20.0241C14.084 20.1086 13.9394 20.3902 14.0239 20.6531C14.1084 20.916 14.39 21.0606 14.6529 20.9762C18.3399 19.7911 20.9999 16.2112 20.9999 12.0001C20.9999 7.78902 18.3399 4.20913 14.6529 3.02412Z"
        fill="currentColor"
      />
      <path
        d="M12.3536 8.14645C12.1583 7.95119 11.8417 7.95119 11.6464 8.14645C11.4512 8.34171 11.4512 8.65829 11.6464 8.85356L14.2929 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2762 3.22386 12.5 3.5 12.5H14.2929L11.6464 15.1464C11.4512 15.3417 11.4512 15.6583 11.6464 15.8536C11.8417 16.0488 12.1583 16.0488 12.3536 15.8536L15.8536 12.3536C15.9473 12.2598 16 12.1326 16 12C16 11.8674 15.9473 11.7402 15.8536 11.6465L12.3536 8.14645Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgLogin;
